module.exports = __webpack_public_path__ + "img/Qualification_4.6759e1c6.jpg";